import { Link } from 'react-router-dom'

const APP_NAME = import.meta.env.VITE_APP_NAME || 'Voltary'

/**
 * Footer minimalista. Solo navegación esencial y legal.
 * El acceso a login vive en los CTAs de cada landing (/login directo).
 */
export function MarketingFooter() {
  return (
    <footer className="marketing-footer">
      <div className="marketing-footer-inner">
        <div className="marketing-footer-brand">
          <span className="marketing-footer-logo">{APP_NAME}</span>
          <p className="marketing-footer-tagline">
            Hosting de servidores de juegos. Paga solo por lo que juegas.
          </p>
        </div>

        <div className="marketing-footer-cols">
          <div className="marketing-footer-col">
            <h4>Navegación</h4>
            <Link to="/">Inicio</Link>
            <Link to="/blog">Blog</Link>
          </div>

          <div className="marketing-footer-col">
            <h4>Legal</h4>
            <Link to="/terms">Términos</Link>
          </div>
        </div>
      </div>

      <div className="marketing-footer-bottom">
        <span>© {new Date().getFullYear()} {APP_NAME}. Todos los derechos reservados.</span>
      </div>
    </footer>
  )
}